import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MpjobService } from 'src/app/services/jobs/mpjob.service';
import { formIdLists, testReasonLists } from '../../_models/staticArray';
import { UtilityService } from '../../services/utility.service';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { AssetService } from 'src/app/services/asset.service';
import { FileUploaderService } from 'src/app/services/file-uploader.service';
import { UserDocumentService } from 'src/app/services/user-document.service';
@Component({
  selector: 'breath-alcohol-form',
  templateUrl: './breath-alcohol-form.component.html',
  styleUrls: ['./breath-alcohol-form.component.scss']
})
export class BreathAlcoholFormComponent implements OnInit {
  @Input('jobId') currentJob
  @Input('learnerData') learnerDetails
  @Input('openFilesSideNav') openFilesSideNav
  breatheAlcoholForm: FormGroup
  currentJobId
  candidateList = []
  candidateName: any;
  currentUserDetails: any
  userId
  currentUserId
  formIdList = formIdLists
  testResonList = testReasonLists
  candidateDisabled = false
  files = []
  newFiles = []
  previousIndex: any;
  queue: any;
  breathAlcoholFormDetails: any;
  isEdit = false
  loading = false
  otherFormDetails
  constructor(
    public _mpJobService: MpjobService,
    public _formBuilder: FormBuilder,
    public _activatedRoute: ActivatedRoute,
    public _router: Router,
    public _utilityService: UtilityService,
    public _assetService: AssetService,
    public uploader: FileUploaderService,
    public _userDocumentService: UserDocumentService
  ) {
    this.queue = this.uploader.queue;
  }

  ngOnInit(): void {
    this.loading = true
    this._activatedRoute.params.subscribe(params => {
      console.log("Params", params)
      if (params.id) {
        this.userId = params.id
      }
      if (params.jobId) {
        this.currentJobId = params.jobId
        this.getCandidateList()
      }
    })
    this.createForm()
  }


  ngOnChanges(chanages: SimpleChanges) {

    if (chanages.currentJob && chanages.currentJob.currentValue) {
      console.log('currentJob', chanages.currentJob.currentValue)
      this.currentJobId = chanages.currentJob.currentValue
      console.log('currentJobId', this.currentJobId)
      this.getCandidateList()
    }
    if (chanages.learnerDetails && chanages.learnerDetails.currentValue) {
      this.currentUserDetails = chanages.learnerDetails.currentValue
      console.log("CURRENT USER DETAILS", this.currentUserDetails)
      this.currentUserId = this.currentUserDetails.userModelId
      this.getBreatheAlcoholForm()
    }
  }



  // FORM CONTROL


  createForm(data?: any) {
    console.log("DATA WHILE EDIT FORM", data)
    this.breatheAlcoholForm = this._formBuilder.group({
      candidateName: new FormControl((data && data.candidateName) ? data.candidateName : this.candidateName, Validators.required),
      dobDate: new FormControl((data && data.dobDate) ? data.dobDate : (this.otherFormDetails && this.otherFormDetails.dob) ? this.otherFormDetails.dob : ''),
      formOfId: new FormControl((data && data.formOfId) ? data.formOfId : (this.otherFormDetails && this.otherFormDetails.confirmId) ? this.otherFormDetails.confirmId : ''),
      otherFormofId: new FormControl((data && data.otherFormofId) ? data.otherFormofId : ''),
      date: new FormControl((data && data.date) ? data.date : (this.otherFormDetails && this.otherFormDetails.formDate) ? this.otherFormDetails.formDate : ''),
      location: new FormControl((data && data.location) ? data.location : (this.otherFormDetails && this.otherFormDetails.location) ? this.otherFormDetails.location : ''),
      testReason: new FormControl((data && data.testReason) ? data.testReason : (this.otherFormDetails && this.otherFormDetails.reasonForTest) ? this.otherFormDetails.reasonForTest : ''),
      donorDate: new FormControl((data && data.donorDate) ? data.donorDate : ''),
      donorSign: new FormControl((data && data.donorSign) ? data.donorSign : ''),
      testResult1Time: new FormControl((data && data.testResult1Time) ? data.testResult1Time : ''),
      testResult1Reading: new FormControl((data && data.testResult1Reading) ? data.testResult1Reading : ''),
      enableTestResult2: new FormControl((data && data.enableTestResult2) ? data.enableTestResult2 : ''),
      testResult2Time: new FormControl((data && data.testResult2Time) ? data.testResult2Time : ''),
      testResult2Reading: new FormControl((data && data.testResult2Reading) ? data.testResult2Reading : ''),
      testResultCheckbox: new FormControl((data && data.testResultCheckbox) ? data.testResultCheckbox : ''),
      print1: new FormControl((data && data.print1) ? data.print1 : ''),
      sign1: new FormControl((data && data.sign1) ? data.sign1 : ''),
      date1: new FormControl((data && data.date1) ? data.date1 : ''),
      print2: new FormControl((data && data.print2) ? data.print2 : ''),
      sign2: new FormControl((data && data.sign2) ? data.sign2 : ''),
      date2: new FormControl((data && data.date2) ? data.date2 : ''),
      print3: new FormControl((data && data.print3) ? data.print3 : ''),
      sign3: new FormControl((data && data.sign3) ? data.sign3 : ''),
      date3: new FormControl((data && data.date3) ? data.date3 : ''),
    })
  }


  // UTILITY

  /**
   * @param formControl control name of different signature
   * Open signature pad and get signature
   * Assign signature to formControl
   */

  addSignature(formControl) {
    this._utilityService.commonDialogBoxOpen(SignaturePadComponent)
      .afterClosed()
      .subscribe(data => {
        if (data === undefined) return
        else {
          this.breatheAlcoholForm.controls[formControl].setValue(data)
        }
        console.log("data from signature", this.breatheAlcoholForm.value)
      })
  }


  addReading(formControl) {
    console.log("formControl", formControl)
    const controlValue = this.breatheAlcoholForm.controls[formControl].value
    const firstReading = this.breatheAlcoholForm.controls['testResult1Reading'].value
    const secondReading = this.breatheAlcoholForm.controls['testResult2Reading'].value
    console.log("firstReading", firstReading, "secondReading", secondReading)
    if ((firstReading && firstReading < 13) || (secondReading && secondReading < 13)) {
      console.log("UNDER 13")
      this.breatheAlcoholForm.controls['testResultCheckbox'].setValue(true)
    } else {
      console.log("REMOVE CHECKBOX")
      this.breatheAlcoholForm.controls['testResultCheckbox'].setValue(false)
    }
    console.log("controlValue", controlValue)

  }

  onChange(event, formControl) {
    this.breatheAlcoholForm.controls[formControl].setValue(event)
    console.log("VALUE OF FORM ", this.breatheAlcoholForm.value)
  }

  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent, obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
      console.log("The queue recieved is", fileQueue);
      if (fileQueue == undefined || fileQueue.length == 0) return;
      fileQueue.forEach(file => {
        if (this.isEdit) this.newFiles.push(file)
        else this.files.push(file);
      })
    })
  }

  fileDetails(event) {
    this._assetService.displayFile(event)
  }

  deleteFile(event, index) {
    this.files.splice(index, 1)
    console.log("after file removd", this.files);
  }

  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }

  optionClicked(user) {
    console.log("VALUE OF CURRENT FORM", this.breatheAlcoholForm.value, user)
    let index = this.candidateList.findIndex(x => x.userModelId === user.userModelId)
    console.log("CURRENT INDEX ", index)
    if (index >= 0) {
      console.log("FIND USER VALUE", this.candidateList[index])
      this.currentUserId = this.candidateList[index].userModelId
    }
  }

  // API CALL


  /**
   * Get all candidate list by job id
   */
  getCandidateList() {
    this._mpJobService.getAllCandidateList(this.currentJobId).subscribe(res => {
      console.log('res in form', res)
      this.candidateList = res
      let index = this.candidateList.findIndex(x => x.userId === this.userId)
      if (index > -1) {
        console.log('seletcted Candidate', this.candidateList[index])
        this.candidateName = this.candidateList[index].name
        this.breatheAlcoholForm.controls.candidateName.setValue(this.candidateName);
        this.candidateDisabled = true
      }
      console.log("ALL CANDIDATE LIST", this.candidateList)
      this.loading = false
    }, error => {
      console.log("error while get candidate list", error)
      this.loading = false
    })
  }

  submitBreathAlcoholForm() {
    console.log("this.breatheAlcoholForm.value", this.breatheAlcoholForm.value)
    this.loading = true
    let obj = {
      metaObj: {
        title: 'breathAlcoholForm',
      },
      documentId: this.currentJobId,
      userId: this.currentUserId,
      onModel: 'mpjob',
      files: this.files,
      details: {}
    }
    let details = {
      breathAlcoholForm: this.breatheAlcoholForm.value
    }
    obj['details'] = details
    if (this.isEdit) {
      obj['userDocumentId'] = this.breathAlcoholFormDetails._id
      obj['documentMetaId'] = this.breathAlcoholFormDetails.documentMetaId._id
      obj['newFiles'] = this.newFiles
      console.log("THIS IS THE UPDATE DOCUMENT", obj)
      this._userDocumentService.updateUserDocument(obj).subscribe((response) => {
        console.log("response of new user document", response);
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "Breathalcohol form updated successfully!", button: "OK" })
        this._router.navigateByUrl('/mpjob/' + this.currentJobId)
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
        this.loading = false
      })

    } else {
      this._userDocumentService.addUserDocument(obj).subscribe((response) => {
        console.log("response of new user document", response);
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "Breathalcohol form added successfully!", button: "OK" })
        this._router.navigateByUrl('/mpjob/' + this.currentJobId)
        // this.redirect()
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
        this.loading = false
      })
      console.log("THIS IS THE FINAL OBJ TO SEND", obj)
    }
  }


  getBreatheAlcoholForm() {
    let obj = {
      accidentId: this.currentJobId,
      userId: this.currentUserId,
      type: 'breathAlcoholForm',
      testedIndividualId: this.currentUserDetails.userId
    }
    this._userDocumentService.getBreathAlcoholDocument(obj).subscribe((response) => {
      console.log("THIS IS THE RESPONSE OF ALL FORMS", response)
      if (response.document && response.document.length) {
        const formDetails = response.document.find((x) => x.documentMetaId.title === 'breathAlcoholForm')
        if (formDetails !== undefined) {
          this.breathAlcoholFormDetails = formDetails
        }

        // const otherFormDetails = response.find((x) => x.documentMetaId.title === 'poctTestForm')
        // if (otherFormDetails !== undefined) {
        //   this.otherFormDetails = otherFormDetails.details.poctTestForm
        //   console.log("OTHER FORM DETAILS", this.otherFormDetails)
        // }
      }
      this.otherFormDetails = response.common 
      console.log("THIS IS THE COMMON DETAILS", this.otherFormDetails)
      // this.breathAlcoholFormDetails = response
      this.loading = false
      // console.log("RESPONSE OF BREATH ALCOHOL FORM", this.breathAlcoholFormDetails);
      if (this.breathAlcoholFormDetails) {
        this.isEdit = true
        this.files = this.breathAlcoholFormDetails.files
        this.createForm(this.breathAlcoholFormDetails.details.breathAlcoholForm)
      } else {
        this.createForm()
      }
    }, error => {
      console.log("ERROR WHILE GET USER FORM", error)
      this.loading = false
    })
  }

}
